
<div class="p-grid">
    <div class="p-col-12 page-header">Message Board</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="p-col-12">
        <div class="p-grid">
            <div class="p-col-12 p-lg-2 p-md-2">
                <p-button styleClass="fullwidthbtn" label="New Message" routerLink="/message/add"></p-button>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2">
                <p-button styleClass="fullwidthbtn" label="Settings" (click)="OpenSettingDialog()"></p-button>
            </div>
            <div class="p-col-12 p-lg-4 p-md-4">
                <div class="p-inputgroup">
                    <input type="search" pInputText [(ngModel)]="searchText" placeholder="Search Message" (keyup.enter)="searchMessage()">
                    <p-button styleClass="fullwidthbtn" icon="pi pi-search" (click)="searchMessage()"></p-button>
                </div>
            </div>
            <div class="p-col-12 p-lg-4 p-md-4">
                <p-dropdown [options]="messageSourceTypeOptions"
                            [(ngModel)]="selectedMessageSourceTypeId"
                            (onChange)="messageSourceTypeOnChange()">
                </p-dropdown>
            </div>
        </div>
    </div>
    <div class="p-col-12" style="margin-top: -15px;">
        <div class="card">
            <div id="dataListWrapper">
                <p-dataView #dv
                            [value]="messages"
                            [paginator]="isPaginator"
                            filterBy="HeadLine,BroadcastBody,PostingUserName,PubDate"
                            [rows]="rowsPerPage"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [lazy]="true"
                            (onLazyLoad)="lazyLoadMessages($event)"
                            [totalRecords]="totalRecords"
                            responsiveLayout="scroll">
                    <ng-template let-message pTemplate="listItem">
                        <div class="p-col-12">
                            <div class="object-list-item">
                                <div class="object-list-detail">
                                    <div class="object-description"><b>{{message.ContactName}}</b> posted a message on {{message.PubDate | convertToDatetime}}</div>
                                    <div class="object-name">
                                        <i class="pi pi-star" style="font-size: 1.3rem; padding-right: .3rem;"
                                           [ngStyle]="{'color': (message.IsFavorite) ? '#D99F00' : '#E1E3E3'}" (click)="UpdateMessageFavorite(message)">
                                        </i>
                                        <span>{{message.HeadLine}}</span>
                                    </div>
                                    <div class="object-description">{{removeHTML(message.BroadcastBody) | slice:0:200}}...</div>
                                    <a routerLink="/message/{{message.Id}}"><span [class]="'object-badge status-red'">READ MORE</span></a>
                                </div>
                                <div class="object-list-action">
                                    <b>Message #{{message.Id}}</b>                                  
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-dataView>
            </div>
        </div>
    </div>
</div>

<p-dialog draggable="false" modal="true" header="Opportunity Broadcast Settings"
          [(visible)]="showSettingDialog"
          [style]="{width: '50vw'}"
          [baseZIndex]="10000"
          [draggable]="false"
          [resizable]="false"
          [closable]="false"
          [modal]="true">
    <p-divider></p-divider>
    <div class="p-grid">
        <p-messages severity="info">
            <ng-template pTemplate>                
                <div class="ml-2">
                    Keep all categories checked to receive broadcasts for all types.
                    Uncheck categories to not receive information.
                </div>
            </ng-template>
        </p-messages>
        <div class="p-col-12 p-lg-6">
            <h6>Property Type</h6>
            <div *ngFor="let propertytype of propertyTypeOptions" class="p-field-checkbox">
                <p-checkbox name="propertytypegroup" value="propertytype"
                            [value]="propertytype"
                            [(ngModel)]="userSettings.PropertyTypeList"
                            [inputId]="propertytype.Id"></p-checkbox>
                <label>{{propertytype.Description}}</label>
            </div>
        </div>
        <div class="p-col-12 p-lg-6">
            <h6>Deal Type</h6>
            <div *ngFor="let dealtype of dealTypeOptions" class="p-field-checkbox">
                <p-checkbox name="dealtypegroup" value="dealtype"
                            [value]="dealtype"
                            [(ngModel)]="userSettings.DealTypeList"
                            [inputId]="dealtype.Id"></p-checkbox>
                <label>{{dealtype.Description}}</label>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button (click)="saveUserSetting()" label="Save" styleClass="p-button-text"></p-button>
        <p-button (click)="cancelUserSetting()" label="Cancel" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

